import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import InGameHeader from '../gamePlayComponents/InGameHeader';

const CourseGameLayout = () => {
  const { course } = useParams();

  return (
    <>
      <InGameHeader currentCourse={course} />
      <Outlet />
      <div id={'bottom spacer'} style={{ height: '16px', width: '100%' }} />
    </>
  );
};

export default CourseGameLayout;
